import React from 'react';

const ColorSwatchStyles = ({ colors }) => {
  if (!colors || colors.length <= 0) return null;

  return (
    <style>
      {colors.map(
        (swatchColor) =>
          `.swatch-${swatchColor.id} {
               ${
                 swatchColor.id === 29
                   ? `
                  background: url("https://csf.global.ssl.fastly.net/variants/${swatchColor.id}/swatch.png") no-repeat center;
                  -webkit-background-size: contain;
                  -moz-background-size: contain;
                  -o-background-size: contain;
                  background-size: contain;`
                   : `
                  background: ${
                    swatchColor.startColorCode || 'red'
                  }; /* For browsers that do not support gradients */
                  background: -webkit-linear-gradient(left, ${swatchColor.startColorCode}, ${
                    swatchColor.endColorCode
                  }); /* For Safari 5.1 to 6.0 */
                  background: -o-linear-gradient(right, ${swatchColor.startColorCode}, ${
                    swatchColor.endColorCode
                  }); /* For Opera 11.1 to 12.0 */
                  background: -moz-linear-gradient(right, ${swatchColor.startColorCode}, ${
                    swatchColor.endColorCode
                  }); /* For Firefox 3.6 to 15 */
                  background: linear-gradient(to right, ${swatchColor.startColorCode}, ${
                    swatchColor.endColorCode
                  }); /* Standard syntax (must be last) */

                  ${
                    swatchColor.swatchImageUrl
                      ? `background: url("${swatchColor.swatchImageUrl}") no-repeat center;
                  background-size: contain;`
                      : ''
                  }
                  `
               }
           }
           .swatch-${swatchColor.id} .out-of-stock::before, .swatch-${swatchColor.id} .out-of-stock::after {
               background: ${swatchColor.id === 29 ? '#fff' : swatchColor.isColorLight ? '#000' : '#fff'}
           }`
      )}
    </style>
  );
};

export default ColorSwatchStyles;
